@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import 'mixins.scss';

$content-padding: 0.6rem;

.textareaContainer {
  @include barlow(16);

  label {
    color: _palette(text-primary);
    display: block;
    margin: 0.125rem 0 0.3125rem 0;
  }

  &:hover {
    & > label {
      color: _palette(secondary);
    }
  }

  .textarea {
    outline: none;

    padding: $content-padding - $border-width;
    border: $border-width solid _palette(black-25);
    border-radius: $border-radius;

    &.readOnly {
      white-space: pre-wrap;
      background-color: white;
      overflow: auto;
      line-height: normal;
    }

    &:not(.readOnly) {
      &:hover,
      &:focus,
      &:hover:focus {
        border: $border-width-thick solid _palette(secondary);
        padding: $content-padding - $border-width-thick;
      }
    }
  }
}
